import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Box as MuiBox } from "@mui/material";
import { DataGridPro as MuiDataGrid } from "@mui/x-data-grid-pro";
import { useAlerts } from "common";
import { LoadingGridOverlay } from "common/components/DataGrid/LoadingGridOverlay";
import { NoRowsGridOverlay } from "common/components/DataGrid/NoRowsGridOverlay";
import { LOADER_TYPES } from "app/shared/constants";
import { useProspectContext } from "app/services/prospectContext";
import { getAllLookupProspects } from "app/services/prospectServices";
import { defaultTableColumnHeaders } from "./ProspectTableConfig";
import { tableStyles } from "app/shared/UI/sharedStyles";

const ProspectListingPageContent = () => {
  const { filters, initialLoad, pagination, setPagination, sort, setSort } =
    useProspectContext();

  const { t } = useTranslation();
  const [lookupProspectList, setLookupProspectList] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const { setAlert } = useAlerts();

  const initialLoading = {
    lookUpProspectDashboardData: true,
  };

  const [isLoading, setIsLoading] = useState(initialLoading);
  // Pseudo-reducer to keep loading states updated
  const setLoader = (type, isSet) => {
    setIsLoading((prev) => ({
      ...prev,
      [type]: isSet,
    }));
  };

  useEffect(() => {
    getAllLookupProspects(
      setLookupProspectList,
      setTotalCount,
      setAlert,
      filters,
      pagination,
      sort,
      setLoader
    );
    // eslint-disable-next-line
  }, [pagination, sort, filters]);

  const NoStudyOverlay = () =>
    !initialLoad ? (
      <NoRowsGridOverlay message={t(`common.emptyTableRow`)} />
    ) : (
      <NoRowsGridOverlay
        message={t(`LookupProspect.messageOnTableInitialLoad`)}
      />
    );

  const handleSortChange = (sortModel) => {
    setSort({
      orderBy: sortModel[0].field,
      order: sortModel[0].sort,
    });
  };

  const handlePaginationModelChange = (model) => {
    setPagination({
      ...pagination,
      page: model.page,
      rowsPerPage: model.pageSize,
    });
  };

  return (
    <MuiBox
      id="pep-my-studies-table-box"
      sx={{ width: "100%", overflow: "auto", pb: 2 }}
    >
      <MuiDataGrid
        slots={{
          loadingOverlay: LoadingGridOverlay,
          noRowsOverlay: NoStudyOverlay,
        }}
        rows={lookupProspectList}
        getRowId={(row) => row.id}
        columns={defaultTableColumnHeaders(t)}
        autoHeight
        pagination
        disableColumnMenu
        disableColumnResize
        disableColumnReorder
        disableMultipleColumnsSorting
        disableRowSelectionOnClick
        loading={isLoading[LOADER_TYPES.LOOKUP_PROSPRECT_DASHBOARD_DATA]}
        paginationMode="server"
        sortingMode="server"
        pageSizeOptions={[10, 20, 50, 100]}
        paginationModel={{
          page: pagination.page,
          pageSize: pagination.rowsPerPage,
        }}
        rowCount={totalCount}
        onPaginationModelChange={handlePaginationModelChange}
        sortModel={[{ field: sort.orderBy, sort: sort.order }]}
        sortingOrder={["asc", "desc"]}
        onSortModelChange={handleSortChange}
        getRowClassName={(params) =>
          params.indexRelativeToCurrentPage % 2 === 0 ? "Mui-even" : "Mui-odd"
        }
        sx={tableStyles}
        columnHeaderHeight={60}
        getRowHeight={() => "auto"}
      />
    </MuiBox>
  );
};

export default ProspectListingPageContent;
